import React, {Component} from 'react'
import {Line} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {LineElement as LineElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: LineElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class LineElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Line
                width={element.width}
                height={element.height}
                opacity={element.opacity}
                id={element.id}
                key={element.id}
                draggable={draggable}
                points={element.points}
                stroke={element.stroke}
                strokeScaleEnabled={false}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
